import React from 'react';
import BoostedComponent from './BoostedComponent'
import moment from 'moment-with-locales-es6';

class DateInput extends React.Component {
  constructor(props) {
    super(props);

    let format = (this.props.format) ? this.props.format : 'yy-mm-dd';

    this.state = {
      time: this.props.value ? Date.utc(this.props.value*1000) : '',
      format: format,
      textVal: null,
    }
  }
  componentDidMount() {
    let onChange = this.props.onChange;
    let ThisComponent = this
    window.jQuery(this.refs.mainInput).datepicker({
      changeMonth: true,
      changeYear: true,
      showOtherMonths: true,
      selectOtherMonths: true,
      firstDay: 0,
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      monthNames: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
      dayNamesShort: [ "Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam" ],
      monthNamesShort: [ "Jan.", "Fev.", "Mar.", "Avr.", "Mai", "Juin", "Juil.", "Août", "Sep.", "Oct.", "Nov.", "Déc." ],

      dateFormat: this.props.format,
      onSelect: function (e, a) {
        let date = window.jQuery(ThisComponent.refs.mainInput).datepicker("getDate");

        if (ThisComponent.props.onChange) ThisComponent.props.onChange(date.getTime() - date.getTimezoneOffset()*60*1000);
        window.jQuery(ThisComponent.refs.mainInput).blur()
      }
    });
    window.jQuery(this.refs.mainInput).datepicker("setDate", this.state.time);

    if (this.props.maxDate) {
      let maxDate = new Date(this.props.maxDate + new Date().getTimezoneOffset()*60*1000)
      window.jQuery(this.refs.mainInput).datepicker("option", "maxDate", maxDate);
    }
    if (this.props.minDate) {
      let minDate = new Date(this.props.minDate + new Date().getTimezoneOffset()*60*1000)
      window.jQuery(this.refs.mainInput).datepicker("option", "minDate", minDate);
    }
  }
  componentDidUpdate(prevProps,prevState) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        time: this.props.value
      })
      let date = new Date(this.props.value + new Date().getTimezoneOffset()*60*1000)
      window.jQuery(this.refs.mainInput).datepicker("setDate", date);
    }
    if (this.props.maxDate!== prevProps.maxDate) {
      let maxDate = new Date(this.props.maxDate + new Date().getTimezoneOffset()*60*1000)
      window.jQuery(this.refs.mainInput).datepicker("option", "maxDate", maxDate);
    }
    if (this.props.minDate!== prevProps.minDate) {
      let minDate = new Date(this.props.minDate + new Date().getTimezoneOffset()*60*1000)
      window.jQuery(this.refs.mainInput).datepicker("option", "minDate", minDate);
    }
  }
  render() {
    return (
      <input ref="mainInput" className="dateInput" defaultValue={this.textVal} onChange={this.updateDate} />
    )
  }
}

export default DateInput;



// WEBPACK FOOTER //
// ./src/DateInput.js